module.exports = __webpack_public_path__ + "media/stage-select.ad28b4a1.mp3";